import { render, staticRenderFns } from "./pdfReview_mp.vue?vue&type=template&id=387e9a40&scoped=true"
import script from "./pdfReview_mp.vue?vue&type=script&lang=js"
export * from "./pdfReview_mp.vue?vue&type=script&lang=js"
import style0 from "./pdfReview_mp.vue?vue&type=style&index=0&id=387e9a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e9a40",
  null
  
)

export default component.exports